import BasePerimeter from '@/kindergarten/perimeters/BasePerimiter';

export default new BasePerimeter({
  purpose: 'auth',

  can: {
    route() {
      return this.child && this.isDriver();
    },
  },
});



// WEBPACK FOOTER //
// ./src/kindergarten/perimeters/DriverPerimeter.js